/**
 * 提现记录列表
 **/


import React from 'react';
import {connect} from 'react-redux';
import {Button, Cascader, Col, Form, Input, message, Row} from "antd";
import styled from "styled-components";
import {bindActionCreators} from "redux";
import {fetchUserAddresses} from "../../redux/actions/userAddress";
import City from "../../components/City";
import {BizRegex} from "../../services/global";


const ModalContentFootTools = styled.div`
    //border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    border-radius: 0 0 4px 4px;
    
    button+button {
      margin-left: 8px;
      margin-bottom: 0;
    }
`

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 4},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
    },
};




class UserAddressForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
        }
    }


    componentDidMount() {

    }


    componentWillReceiveProps(nextProps) {

    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }


    resetFormFields = () => {
        this.props.form.resetFields();
    }

    submitForm = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                if (!this.props.submitServiceFunc) {
                    return;
                }


                var _values = Object.assign({userId: this.props.userId}, values);
                _values.province = _values.fullarea[0]
                _values.city = _values.fullarea[1]
                _values.subCity = _values.fullarea[2]

                delete _values.fullarea;

                this.props.submitServiceFunc(_values).then(res => {
                    if (res.code == 200) {
                        message.info("成功!");
                        this.props.submitSuccessCallback(res);
                    } else {
                        message.error(res.msg,6);

                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            }

        })
    }

    render() {
        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;
        const addr = this.props.addr;
        return (
            <div>
                <Row>
                    <div style={{display: "none"}}>
                        {getFieldDecorator(`id`, {
                            initialValue: addr ? addr.id : null,
                            rules: [{required: false}],
                        })(
                            <Input/>
                        )}
                        {getFieldDecorator(`addressId`, {
                            initialValue: addr ? addr.id : null,
                            rules: [{required: false}],
                        })(
                            <Input/>
                        )}
                    </div>
                    <Col span={24}>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    收货人
                                </span>
                            )}
                            hasFeedback
                        >
                            {getFieldDecorator('recipientName', {
                                initialValue: addr ? addr.recipientName : null,
                                rules: [
                                    {required: true, message: '收货人'},
                                    {whitespace:true, message: '不能输入空格!'},{min: 2, max: 100, message: '长度限制为1至100个之间!'}
                                ],
                            })(
                                <Input/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    所在地区
                                </span>
                            )}
                            hasFeedback
                        >
                            {getFieldDecorator('fullarea', {
                                initialValue: addr ? [addr.province, addr.city, addr.subCity] : null,
                                rules: [
                                    {required: true, message: '所在地区'}
                                ],
                            })(
                                <Cascader placeholder={"请选择"} options={City} style={{width: 300}}/>
                            )}
                        </Form.Item>
                        {/*<span>{addr.province}{addr.city}{addr.subCity}</span>*/}
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    地址
                                </span>
                            )}
                            hasFeedback
                        >
                            {getFieldDecorator('location', {
                                initialValue: addr ? addr.location : null,
                                rules: [
                                    {required: true, message: '地址'},
                                    {whitespace:true, message: '不能输入空格!'},{min: 2, max: 500, message: '长度限制为1至100个之间!'}
                                ],
                            })(
                                <Input.TextArea autosize={{minRows: 2, maxRows: 6}}/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    联系电话
                                </span>
                            )}
                            hasFeedback
                        >
                            {getFieldDecorator('recipientPhone', {
                                initialValue: addr ? addr.recipientPhone : null,
                                rules: [
                                    {required: true, message: '联系电话'},
                                    {pattern: BizRegex.phone, message: '长度限制为5至20个之间，支持：数字,-,+和()'}
                                ],
                            })(
                                <Input/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                    邮编
                                </span>
                            )}
                            hasFeedback
                        >
                            {getFieldDecorator('postalCode', {
                                initialValue: addr ? addr.postalCode : null,
                                rules: [
                                    {required: false, message: '邮编'},{pattern: BizRegex.noblank, message: '不能输入空格!'},{min: 4, max: 10, message: '长度限制为4至10个之间!'}
                                ],
                            })(
                                <Input/>
                            )}
                        </Form.Item>
                    </Col>


                </Row>
                <ModalContentFootTools>
                    <Button key="back" onClick={this.props.cancelCallback}>
                        放弃
                    </Button>
                    <Button key="submit" type="primary" loading={this.state.formLoading} onClick={() => {
                        this.submitForm();
                    }}>
                        保存
                    </Button>
                </ModalContentFootTools>
            </div>
        )
    }
}


UserAddressForm.contextTypes = {};

UserAddressForm.defaultProps = {
    userId: null,
    addr: null,
    submitServiceFunc: null,
    submitSuccessCallback: null,
};

UserAddressForm.propTypes = {}

const mapStateToPorps = state => {
    const userAddresses = state.userAddresses;
    const {lastLocation} = state.global;
    const cmEnums = state.cmEnums;
    return {lastLocation, cmEnums, userAddresses};
};
const mapDispatchToProps = dispatch => ({
    fetchUserAddresses: bindActionCreators(fetchUserAddresses, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(UserAddressForm));





// WEBPACK FOOTER //
// ./src/containers/user/UserAddressForm.jsx